import styled from "styled-components";

const LandingLogoCard = styled.div`
  position: relative;
  height: 100%;
  width: 100%;
`;

const LandingLogo = () => {
  return (
    <LandingLogoCard>
      <svg
        width="62"
        height="48"
        viewBox="0 0 83 64"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M72.2732 23.5477C77.3813 23.5477 81.5222 27.6887 81.5222 32.7967C81.5222 37.9048 77.3813 42.0457 72.2732 42.0458C67.1651 42.0458 63.0242 37.9048 63.0242 32.7967C63.0242 27.6887 67.1651 23.5477 72.2732 23.5477Z"
          fill="#FFEEEE"
          stroke="#FF8A8A"
          strokeWidth="2"
        />
        <path
          d="M29.2275 1C34.3356 1.00001 38.4766 5.14095 38.4766 10.249C38.4765 15.3571 34.3356 19.498 29.2275 19.498C24.1195 19.498 19.9785 15.3571 19.9785 10.249C19.9785 5.14094 24.1195 1 29.2275 1Z"
          fill="#FFEEEE"
          stroke="#FF8A8A"
          strokeWidth="2"
        />
        <path
          d="M10.249 42.0504C15.3571 42.0504 19.498 46.1914 19.498 51.2994C19.498 56.4075 15.3571 60.5484 10.249 60.5485C5.14095 60.5485 1.00001 56.4075 1 51.2994C1 46.1914 5.14094 42.0504 10.249 42.0504Z"
          fill="#FFEEEE"
          stroke="#FF8A8A"
          strokeWidth="2"
        />
        <path
          d="M63.5605 10.2239C66.1214 10.2239 68.1971 12.2998 68.1973 14.8606C68.1973 17.4216 66.1215 19.4974 63.5605 19.4974C60.9997 19.4972 58.9238 17.4215 58.9238 14.8606C58.924 12.2999 60.9998 10.224 63.5605 10.2239Z"
          fill="#FFEEEE"
          stroke="#FF8A8A"
          strokeWidth="2"
        />
        <path
          d="M15.9028 22.5217C18.1806 22.5217 20.0276 24.368 20.0278 26.6457C20.0278 28.9236 18.1807 30.7707 15.9028 30.7707C13.6252 30.7705 11.7788 28.9235 11.7788 26.6457C11.7791 24.3682 13.6253 22.522 15.9028 22.5217Z"
          fill="#FFEEEE"
          stroke="#FF8A8A"
          strokeWidth="2"
        />
        <path
          d="M49.2124 53.2688C51.7732 53.2688 53.849 55.3447 53.8491 57.9055C53.8491 60.4665 51.7733 62.5423 49.2124 62.5423C46.6516 62.5421 44.5757 60.4664 44.5757 57.9055C44.5758 55.3448 46.6517 53.2689 49.2124 53.2688Z"
          fill="#FFEEEE"
          stroke="#FF8A8A"
          strokeWidth="2"
        />
        <path
          d="M42.0376 26.6217C45.7305 26.6217 48.724 29.6153 48.7241 33.3082C48.7241 37.0012 45.7306 39.9948 42.0376 39.9948C38.3447 39.9946 35.3511 37.0011 35.3511 33.3082C35.3512 29.6154 38.3448 26.6218 42.0376 26.6217Z"
          fill="#FFEEEE"
          stroke="#FF8A8A"
          strokeWidth="2"
        />
        <rect
          x="60.6539"
          y="19.2221"
          width="16.04"
          height="1.94967"
          transform="rotate(139.63 60.6539 19.2221)"
          fill="#FF8A8A"
          stroke="#FF8A8A"
          strokeWidth="0.5"
        />
        <rect
          x="49.0388"
          y="31.641"
          width="13.547"
          height="1.94967"
          fill="#FF8A8A"
          stroke="#FF8A8A"
          strokeWidth="0.5"
        />
        <rect
          x="35.2616"
          y="17.9599"
          width="9.65037"
          height="1.94967"
          transform="rotate(59 35.2616 17.9599)"
          fill="#FF8A8A"
          stroke="#FF8A8A"
          strokeWidth="0.5"
        />
        <path
          d="M35.3147 30.6774L34.8431 32.5688L20.1427 28.9036L20.6143 27.0122L35.3147 30.6774Z"
          fill="#FF8A8A"
          stroke="#FF8A8A"
          strokeWidth="0.5"
        />
        <rect
          x="17.5486"
          y="45.4013"
          width="20.1777"
          height="1.94967"
          transform="rotate(-29 17.5486 45.4013)"
          fill="#FF8A8A"
          stroke="#FF8A8A"
          strokeWidth="0.5"
        />
        <rect
          x="46.8081"
          y="53.485"
          width="13.6733"
          height="1.94967"
          transform="rotate(-105 46.8081 53.485)"
          fill="#FF8A8A"
          stroke="#FF8A8A"
          strokeWidth="0.5"
        />
      </svg>
    </LandingLogoCard>
  );
};

export default LandingLogo;
